import { Stack } from '@mui/material'

import LinearChart from 'components/cattles/lamenessPage/shared/LinearChart'
import { useGetMilkYieldChart } from 'hook/query/useGetMilkYieldChart'
import { useGetStatisticsWidgets } from 'hook/query/useGetStatisticsWidgets'
import moment from 'moment'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { BaseWidget } from '../baseWidget'
import { useGetMilkYieldChartInfo } from './hooks/useGetMilkYieldChartInfo'
import { MilkYieldLinearWidget } from './Table/MilkYieldLinearWidget'

export const MilkYieldLinearChart = () => {
	const { statistics, loading } = useGetStatisticsWidgets()
	const { data } = useGetMilkYieldChart({
		start: moment().startOf('day').valueOf(),
		end: moment().startOf('day').valueOf(),
	})
	const { dotsInfo } = useGetMilkYieldChartInfo({
		total_sell_milk_sum: data?.total_sell_milk_sum,
		total_reject_milk_sum: data?.total_reject_milk_sum,
	})
	const totalMilk =
		(data?.total_reject_milk_sum || 0) + (data?.total_sell_milk_sum || 0)

	const todayLabel = moment().format('DD.MM.YYYY')

	return (
		<BaseWidget
			isLoading={loading}
			path='/milk-yield'
			pathLable='Перейти в надои'
		>
			<Stack direction='row' alignItems='center' gap='8px' mb='24px'>
				<TypographyPrimary16Bold>Надои</TypographyPrimary16Bold>
				<TypographySecondary>{todayLabel}</TypographySecondary>
			</Stack>
			<Stack
				direction='row'
				justifyContent='space-between'
				alignItems='center'
				mb='24px'
			>
				<TypographyPrimary>Всего</TypographyPrimary>
				<TypographyPrimary16Bold>{totalMilk}</TypographyPrimary16Bold>
			</Stack>
			<Stack direction='column' gap='8px'>
				<LinearChart dotsInfo={dotsInfo} totalCount={totalMilk} />
				<MilkYieldLinearWidget
					milkings={[statistics?.milkings]}
					total_reject_milk_sum={data?.total_reject_milk_sum}
					total_sell_milk_sum={data?.total_sell_milk_sum}
				/>
			</Stack>
		</BaseWidget>
	)
}
